export default "https://cdn-static.gokick.com/assets/42f530e1bfe0c3dccbac116cd4d83f20c9a8b744/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";